module.exports = __webpack_public_path__ + "static/media/DESCARGA_E_IMPRIME_EL_ANVERSO_Y_REVERSO_L2_HASHTAG_MAGICO_.ddd85318.pdf";